function getUrl() {
    if (typeof window === 'undefined') return null;
    return new URL(window.location.href);
}

function writeUrl(url) {
    if (!url || typeof window === 'undefined') return;
    window.history.replaceState(window.history.state, '', url.toString());
}

const QueryStorage = {
    get(key, fallback = null) {
        try {
            const url = getUrl();
            if (!url) return fallback;
            const value = url.searchParams.get(key);
            return value === null ? fallback : value;
        } catch {
            return fallback;
        }
    },

    set(key, value) {
        try {
            const url = getUrl();
            if (!url) return;
            if (value === null || value === undefined || value === '') {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, String(value));
            }
            writeUrl(url);
        } catch {
        }
    },

    remove(key) {
        try {
            const url = getUrl();
            if (!url) return;
            url.searchParams.delete(key);
            writeUrl(url);
        } catch {
        }
    },

    clear() {
        try {
            const url = getUrl();
            if (!url) return;
            url.search = '';
            writeUrl(url);
        } catch {
        }
    },
};

export default QueryStorage;
